<template>
	<div class="status-filter-section mb-4">
		<h4>{{ $t('text.filterByStatus') }}</h4>
		<div class="filter-checkboxes">
			<v-checkbox
				v-model="localSelectedStatuses"
				:label="$t('text.Ordered')"
				value="ordered"
				hide-details
			/>
			<v-checkbox
				v-model="localSelectedStatuses"
				:label="$t('text.Cancelled')"
				value="cancelled"
				hide-details
			/>
		</div>
		<div class="filter-actions mt-2">
			<v-btn
				@click="applyFilter"
				variant="outlined"
				size="small"
				:disabled="loading"
				prepend-icon="mdi-filter"
			>
				{{ $t('text.applyFilter') }}
			</v-btn>
			<v-btn
				@click="clearFilter"
				variant="outlined"
				size="small"
				class="ml-2"
				prepend-icon="mdi-filter-remove"
			>
				{{ $t('text.clearFilter') }}
			</v-btn>
		</div>
	</div>
</template>

<script>
export default {
	name: 'StatusFilter',
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		modelValue: {
			type: Array,
			default: () => []
		}
	},
	emits: ['update:modelValue', 'apply', 'clear'],
	data() {
		return {
			localSelectedStatuses: []
		}
	},
	watch: {
		modelValue: {
			handler(newValue) {
				if (JSON.stringify(newValue) !== JSON.stringify(this.localSelectedStatuses)) {
					this.localSelectedStatuses = [...newValue]
				}
			},
			immediate: true
		},
		localSelectedStatuses: {
			handler(newValue) {
				if (JSON.stringify(newValue) !== JSON.stringify(this.modelValue)) {
					this.$emit('update:modelValue', newValue)
				}
			},
			deep: true
		}
	},
	methods: {
		applyFilter() {
			this.$emit('apply', this.localSelectedStatuses)
		},
		clearFilter() {
			this.localSelectedStatuses = []
			this.$emit('clear')
		}
	}
}
</script>

<style scoped>
.status-filter-section {
	padding: 16px;
	background-color: #f8f9fa;
	border-radius: 8px;
	border: 1px solid #e9ecef;
}

.status-filter-section h4 {
	margin-bottom: 12px;
	color: #495057;
	font-weight: 600;
}

.filter-checkboxes {
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	margin-bottom: 8px;
}

.filter-checkboxes .v-checkbox {
	margin-right: 8px;
}

.filter-actions {
	display: flex;
	gap: 8px;
}
</style> 